import { useEffect, useState } from "react";
import styled from "styled-components";
import VideoPoster from "../assets/videos/main-poster.webp";
import Video from "../assets/videos/video-bw.mp4";
import Navbar from "../components/navbar/Navbar";
import PageBreakDefault from "../components/pageBreaks/PageBreakDefault";
import CategorySection from "../components/section/category/CategorySection";
import CharitySection from "../components/section/fillers/CharitySection";
import HandwovenSection from "../components/section/fillers/HandwovenSection";
import Footer from "../components/section/footer/Footer";
import NewsLetterSection from "../components/section/newsletter/NewsletterSection";
import SocialsSection from "../components/section/socials/SocialsSection";

const Wrapper = styled.div`
  position: relative;
`;

const VideoWrapper = styled.div`
  z-index: 1 !important;
  width: fit-content;
  margin: auto;
  video {
    height: ${({ scale }) => `calc(100vh * ${scale})`};
    width: ${({ scale }) => `calc(100vw * ${scale})`};
    z-index: 99;
    object-fit: cover;
    margin: 0 auto;
    transition: transform 0.3s ease-out;
    transform: scale(${({ scale }) => scale});
  }
`;

const Body = styled.div``;

function HomePage() {
  const [scrollValue, setScrollValue] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = Math.min(window.scrollY, 300);
      setScrollValue(scrollTop);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scale = 1 - scrollValue / 5000;

  return (
    <Wrapper>
      <Navbar />
      <VideoWrapper scale={scale}>
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster={VideoPoster}
        >
          <source src={Video} type="video/mp4" />
        </video>
      </VideoWrapper>
      <Body>
        <PageBreakDefault />
        <HandwovenSection />
        <PageBreakDefault />
        <CategorySection />
        {/* <PageBreakDefault /> */}
        {/* <LookSection /> */}
        <PageBreakDefault />
        <CharitySection />
        <PageBreakDefault />
        <NewsLetterSection />
        <PageBreakDefault />
        <SocialsSection />
        <Footer />
      </Body>
    </Wrapper>
  );
}

export default HomePage;
